export default "__VITE_ASSET__CGO0dznU__"